import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import Footer from "../../components/dashboard/footer";
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import tmdbApi from "../../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Loader from "../../components/loader";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../../pages/SessionPopup"
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { useNavigate, useLocation,useParams } from "react-router-dom";


import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ReferenceLine,
  Legend,
  ResponsiveContainer,
} from "recharts";

let { lambda, appname } = window.app



const views = ['DAY', 'WEEK', 'MONTH', 'YEAR'];


const data = [
  { id: 1, name: 'Park City Shop', category: 'Retail', status: 'Active', date: '2025-05-01' },
  { id: 2, name: 'Night Club Deluxe', category: 'Entertainment', status: 'Inactive', date: '2025-04-28' },
  { id: 3, name: 'Sunset Lounge', category: 'Nightlife', status: 'Active', date: '2025-05-05' },
  { id: 4, name: 'Urban Market', category: 'Retail', status: 'Inactive', date: '2025-03-22' },
];



const ViewDashBoard = () => {
  const navigate = useNavigate();
   let { id } = useParams();
  const [view, setView] = useState("DAY");
  const [filterType, setFilterType] = useState("Total");
  const [xAxisData, setXAxisData] = useState([]);
  const [chartData, setChartData] = useState([]);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [locationData, setLocationData] = useState([]);
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [dateRange, setDateRange] = useState({ fromDate: '', toDate: '' });
  const [selectedType, setSelectedType] = useState("Total");
  const [show, setShow] = useState(false)
  const [summary, setSummary] = useState({});
  const [showCalendar, setShowCalendar] = useState(false);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, isRefreshed, setIsRefreshed, userData, clientInfo, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
  const useruniqueid = localStorage.getItem("clientid")
  const [selectedMode, setSelectedMode] = useState("Day");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [range1, setRange1] = useState({ fromDate: '', toDate: '' });
  const [range2, setRange2] = useState({ fromDate: '', toDate: '' });
  const [statisticsData, setStatisticsData] = useState([]);
  const [allCounts, setAllCounts] = useState([])
  const [currentData, setCurrentData] = useState([]);
  const [compareData, setCompareData] = useState([]);
  const [btnLoader, setBtnLoader] = useState(false)
  const calendarRef = useRef(null);
  const [image, setImg] = useState('')
  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   const paymentNotSuccess = clientInfo?.subscriptionPayment !== "PAYMENT SUCCESS";
  //   // const hasSubscriptionPrice = clientInfo?.subscriptionPrice !== "0" && clientInfo?.subscriptionPrice !== 0;

  //   if (!token || (paymentNotSuccess )) {
  //     navigate("/signin");
  //   }
  // }, [clientInfo]);



  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }



  }, [window.site]);
  const handleClickOutside = (e) => {
    if (calendarRef.current && !calendarRef.current.contains(e.target)) {
      setShowCalendar(false);
    }
  };
  useEffect(() => {
    if (showCalendar) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showCalendar]);
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/signin");
      return;
    }

    // Skip if clientInfo is still empty
    if (!clientInfo?.subscriptionPayment) return;

    if (clientInfo.subscriptionPayment !== "PAYMENT SUCCESS") {
      navigate("/signin");
    }
  }, [clientInfo, navigate]);

const columns = [
  { selector: row => row?.data?.name },
  { name: 'Total Completed Reservations', selector: row => row?.data?.completedCount },
  { name: 'Repeat Visitors', selector: row => row?.data?.repeatVisitor },

  { name: 'Walk-Ins', selector: row => row?.data?.walkinPercentage },
  { name: 'Average Visit Duration', selector: row => row?.data?.averageVisitDuration },
  { name: 'Favorites', selector: row => row?.data?.favourites },

];
const countColumns = [
  {
    name: (
      <>
        Total <div className="total-color"></div>
      </>
    ),
    selector: row => row?.data?.totalCount
  },
  {
    name: (
      <>
        Active <div className="active-color"></div>
      </>
    ),
    selector: row => row?.data?.activeCount
  },
  {
    name: (
      <>
        Completed <div className="completed-color"></div>
      </>
    ),
    selector: row => row?.data?.completedCount
  },
  {
    name: (
      <>
        Walk-ins <div className="walk-color"></div>
      </>
    ),
    selector: row => row?.data?.walikinCount
  },
  {
    name: (
      <>
        Canceled <div className="canceled-color"></div>
      </>
    ),
    selector: row => row?.data?.cancelledCount
  },
  {
    name: (
      <>
        Expired <div className="expired-color"></div>
      </>
    ),
    selector: row => row?.data?.expiredCount
  }
];

  console.log("fromDateeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", fromDate)
  console.log("toDateeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", toDate)
  const filteredData = useMemo(() => {
    const key = selectedType.toLowerCase(); // e.g., "total", "completed", etc.

    if (!Array.isArray(chartData)) return [];

    return chartData.map(item => ({
      ...item,
      [key]: selectedType === "Total" ? item.total : (item[key] > 0 ? item[key] : null),
    }));
  }, [selectedType, chartData]);


  const data = [
    { day: 'Mon', week1: 5, week2: -4 },
    { day: 'Tue', week1: 3, week2: -6 },
    { day: 'Wed', week1: 4, week2: -2 },
    { day: 'Thu', week1: 0, week2: 0 },
    { day: 'Fri', week1: 2, week2: -3 },
    { day: 'Sat', week1: 0, week2: 0 },
    { day: 'Sun', week1: 1, week2: -1 },
  ];
  const isWeekData = currentData.length === 7;

  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getWeekdayName = (dateStr) => {
    const fullDate = new Date(`${dateStr}, 2024`);
    return weekDays[fullDate.getDay()];
  };

  const getDayNumber = (dateStr) => {
    const parts = dateStr.split(" ");
    return parts[1]; // e.g., "May 01" → "01"
  };

  const mergedData = currentData.map((item, index) => {
    const r2 = compareData[index];

    let nameLabel;

    if (isWeekData) {
      nameLabel = getWeekdayName(item.name);
    } else if (/\w+\s\d{2}/.test(item.name)) {
      nameLabel = getDayNumber(item.name);
    } else {
      nameLabel = item.name;
    }

    return {
      name: nameLabel,
      completedPositive: item.completed,
      activePositive: item.active,
      cancelledPositive: item.cancelled,
      expiredPositive: item.expired,
      completedNegative: -r2.completed,
      activeNegative: -r2.active,
      cancelledNegative: -r2.cancelled,
      expiredNegative: -r2.expired,
    };
  });


  // Transform the 'previous' dataset to negative for bottom display
  const transformedData = data.map((d) => ({
    ...d,
    previous: -d.previous,
  }));

  const centerYAxisPosition = 150;
  console.log("filterrrrrrrrrrrrrrrrrrrrrrrrrData", filteredData)
  const StackedBarChart = ({ }) => {
    console.log("View:", view);

    // Set barSize based on view
    let barSize = 20; // Default for DAY
    let interval
    if (view === "WEEK") {
      barSize = 80;
    } else if (view === "MONTH") {
      barSize = 50;
      interval = 0
    } else if (view === "YEAR") {
      barSize = 70;
    }

    return (
      <ResponsiveContainer width="100%" height={350}>
        {currentData?.length > 0 && compareData?.length > 0 ?
          <BarChart data={mergedData}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            {/* <Legend /> */}

            {/* Completed Bars */}
            {(selectedType === "Total" || selectedType === "Completed") && (
              <>
                <Bar dataKey="completedPositive" stackId="a" fill="#b187f4" isAnimationActive />
                <Bar dataKey="completedNegative" stackId="b" fill="#b187f4" isAnimationActive />
              </>
            )}

            {/* Active Bars */}
            {(selectedType === "Total" || selectedType === "Active") && (
              <>
                <Bar dataKey="activePositive" stackId="a" fill="#ec90d0" isAnimationActive />
                <Bar dataKey="activeNegative" stackId="b" fill="#ec90d0" isAnimationActive />
              </>
            )}

            {/* Cancelled Bars */}
            {(selectedType === "Total" || selectedType === "Cancelled") && (
              <>
                <Bar dataKey="cancelledPositive" stackId="a" fill="#8bd1ff" isAnimationActive />
                <Bar dataKey="cancelledNegative" stackId="b" fill="#8bd1ff" isAnimationActive />
              </>
            )}

            {/* Expired Bars */}
            {(selectedType === "Total" || selectedType === "Expired") && (
              <>
                <Bar dataKey="expiredPositive" stackId="a" fill="#f7d26e" isAnimationActive />
                <Bar dataKey="expiredNegative" stackId="b" fill="#f7d26e" isAnimationActive />
              </>
            )}
          </BarChart> :
          <BarChart data={filteredData} barSize={barSize}>
            <CartesianGrid strokeDasharray="7 7" vertical={false} horizontal={true} />
            <XAxis dataKey="name" angle={-45} textAnchor="end" height={70} interval={interval} />
            <YAxis />
            <Tooltip />

            {(selectedType === "Total" || selectedType === "Completed") && (
              <Bar dataKey="completed" stackId="a" fill="#b187f4" isAnimationActive />
            )}
            {(selectedType === "Total" || selectedType === "Active") && (
              <Bar dataKey="active" stackId="a" fill="#ec90d0" isAnimationActive />
            )}
            {(selectedType === "Total" || selectedType === "Cancelled") && (
              <Bar dataKey="cancelled" stackId="a" fill="#8bd1ff" isAnimationActive />
            )}
            {(selectedType === "Total" || selectedType === "Expired") && (
              <Bar dataKey="expired" stackId="a" fill="#f7d26e" isAnimationActive />
            )}
          </BarChart>}





      </ResponsiveContainer>


    );
  };
  const getCurrentMonday = () => {
    const today = new Date();
    const day = today.getDay();
    const diff = day === 0 ? -6 : 1 - day; // Adjust for Sunday (0)
    return new Date(today.setDate(today.getDate() + diff));
  };


  console.log("rangeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee1", range1)
  console.log("rangeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee2", range2)


  // Update default dates based on selected mode
  useEffect(() => {
    const now = new Date();

    if (selectedMode === "Day") {
      setFromDate(now);
      setToDate(now);
    } else if (selectedMode === "Week") {
      const monday = getCurrentMonday();
      setFromDate(monday);
      setToDate(monday);
    } else if (selectedMode === "Month") {
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      setFromDate(firstDay);
      setToDate(firstDay);
    } else if (selectedMode === "Year") {
      const janFirst = new Date(now.getFullYear(), 0, 1);
      setFromDate(janFirst);
      setToDate(janFirst);
    }
  }, [selectedMode]);

  // Filter only Mondays for Week mode
  const isMonday = (date) => {
    return date.getDay() === 1;
  };

  // DatePicker props based on selected mode
  const getPickerProps = () => {
    if (selectedMode === "Day") {
      return {
        dateFormat: "dd/MM/yyyy",
      };
    } else if (selectedMode === "Week") {
      return {
        filterDate: isMonday,
        placeholderText: "Select Monday",
        dateFormat: "dd/MM/yyyy",
      };
    } else if (selectedMode === "Month") {
      return {
        showMonthYearPicker: true,
        dateFormat: "MMMM yyyy", // ⬅️ Will show "May 2025" instead of "05/2025"
      };
    } else if (selectedMode === "Year") {
      return {
        showYearPicker: true,
        dateFormat: "yyyy",
      };
    }
  };



  const getPastCurrentFuturePayloads = ({ fromDate, toDate, groupBy }) => {
    const inputFrom = new Date(fromDate);
    const inputTo = new Date(toDate);

    const formatDate = (date, isStart = true) => {
      const d = new Date(date);
      d.setHours(isStart ? 0 : 23, isStart ? 0 : 59, isStart ? 0 : 59, 0);
      const yyyy = d.getFullYear();
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const dd = String(d.getDate()).padStart(2, '0');
      const hh = String(d.getHours()).padStart(2, '0');
      const min = String(d.getMinutes()).padStart(2, '0');
      const sec = String(d.getSeconds()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}T${hh}:${min}:${sec}`;
    };

    let pastFrom, pastTo, futureFrom, futureTo;

    if (groupBy === 'day') {
      const past = new Date(inputFrom);
      past.setDate(past.getDate() - 1);
      const future = new Date(inputFrom);
      future.setDate(future.getDate() + 1);

      pastFrom = formatDate(past, true);
      pastTo = formatDate(past, false);
      futureFrom = formatDate(future, true);
      futureTo = formatDate(future, false);
    }

    else if (groupBy === 'week') {
      const pastStart = new Date(inputFrom);
      pastStart.setDate(pastStart.getDate() - 7);
      const pastEnd = new Date(pastStart);
      pastEnd.setDate(pastEnd.getDate() + 6);

      const futureStart = new Date(inputTo);
      futureStart.setDate(futureStart.getDate() + 1);
      const futureEnd = new Date(futureStart);
      futureEnd.setDate(futureEnd.getDate() + 6);

      pastFrom = formatDate(pastStart, true);
      pastTo = formatDate(pastEnd, false);
      futureFrom = formatDate(futureStart, true);
      futureTo = formatDate(futureEnd, false);
    }

    else if (groupBy === 'month') {
      const prevMonth = new Date(inputFrom);
      prevMonth.setMonth(prevMonth.getMonth() - 1);
      const nextMonth = new Date(inputFrom);
      nextMonth.setMonth(nextMonth.getMonth() + 1);

      const startOfMonth = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01T00:00:00`;
      const endOfMonth = (d) => {
        const last = new Date(d.getFullYear(), d.getMonth() + 1, 0);
        return `${last.getFullYear()}-${String(last.getMonth() + 1).padStart(2, '0')}-${String(last.getDate()).padStart(2, '0')}T23:59:59`;
      };

      pastFrom = startOfMonth(prevMonth);
      pastTo = endOfMonth(prevMonth);
      futureFrom = startOfMonth(nextMonth);
      futureTo = endOfMonth(nextMonth);
    }

    else if (groupBy === 'year') {
      const year = inputFrom.getFullYear();
      pastFrom = `${year - 1}-01-01T00:00:00`;
      pastTo = `${year - 1}-12-31T23:59:59`;
      futureFrom = `${year + 1}-01-01T00:00:00`;
      futureTo = `${year + 1}-12-31T23:59:59`;
    }

    return [
      { fromDate: pastFrom, toDate: pastTo, groupBy },
      { fromDate, toDate, groupBy },
      { fromDate: futureFrom, toDate: futureTo, groupBy }
    ];
  };




  const getDatePickerProps = () => {
    if (view === "Day") {
      return {
        dateFormat: "dd/MM/yyyy",
      };
    } else if (view === "WEEK") {
      return {
        filterDate: isMonday,
        placeholderText: "Select Monday",
        dateFormat: "dd/MM/yyyy",
      };
    } else if (view === "MONTH") {
      return {
        showMonthYearPicker: true,
        dateFormat: "MMMM yyyy", // ⬅️ Will show "May 2025" instead of "05/2025"
      };
    } else if (view === "YEAR") {
      return {
        showYearPicker: true,
        dateFormat: "yyyy",
      };
    }
  };

  const handleCompare = () => {
    setShow(true)
  }


  const getDateRange = (view, currentDate) => {
    let start = new Date(currentDate);
    let end = new Date(currentDate);

    if (view === 'WEEK') {
      const day = start.getDay(); // 0 (Sun) to 6 (Sat)
      const diff = start.getDate() - day + (day === 0 ? -6 : 1); // Monday as the first day of the week
      start.setDate(diff);
      end = new Date(start);
      end.setDate(start.getDate() + 6);
    } else if (view === 'MONTH') {
      start.setDate(1);
      end = new Date(start.getFullYear(), start.getMonth() + 1, 0);
    } else if (view === 'YEAR') {
      start = new Date(start.getFullYear(), 0, 1);
      end = new Date(start.getFullYear(), 11, 31);
    }

    const format = (date, isStart) => {
      const y = date.getFullYear();
      const m = `${date.getMonth() + 1}`.padStart(2, '0');
      const d = `${date.getDate()}`.padStart(2, '0');
      return `${y}-${m}-${d}T${isStart ? '00:00:00' : '23:59:59'}`;
    };

    const startDateStr = format(start, true);
    const endDateStr = format(end, false);

    return {
      fromDate: startDateStr,
      toDate: endDateStr,
      groupBy: view.toLowerCase()
    };
  };
  useEffect(() => {
    if (view && currentDate) {
      const dateRangeData = getDateRange(view, currentDate);
      console.log("dateRangssssssssssssssssssssssssssssssssssssssssss", dateRangeData)
      const payload = selectedStoreId
        ? { ...dateRangeData, storeId: selectedStoreId }
        : dateRangeData;
      getStatstics(payload);
      dashboard(payload); // Call API with correct data
      counts(payload);
      // const [past, current, future] = getPastCurrentFuturePayloads(payload);
    }
  }, [view, currentDate, selectedStoreId]); // Add selectedStoreId to dependencies


  // const dateRangeData = getDateRange(view, currentDate);

  useEffect(() => {

    getStore()
  }, [])



  useEffect(() => {
    setRoute("user")
    // GetUserData();
    setActiveMenuId(200000)
    // setActiveMenuObj({
    //     "Client Management": false,
    //     "Contact Management":false,
    //     "Reports": false
    // })
    // setData([])
    userActivity();
  }, []);
  const userActivity = () => {
    let path = window.location.pathname.split("/");
    const pageName = path[path.length - 1];
    var presentTime = moment();
    let payload;

    payload = {
      "clientid": localStorage.getItem("clientid"),
      "pagename": pageName,
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    const previousId = localStorage.getItem("previousid");
    const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response?.data?.statusCode === 200) {
          localStorage.setItem("previousid", response?.data?.result)
        }
      });
  }
  console.log("chartDatatatattatatatatata", chartData)
  // const shiftDate = (direction) => {
  //   const newDate = new Date(currentDate);

  //   if (view === 'DAY') {
  //     newDate.setDate(newDate.getDate() + direction);
  //   } else if (view === 'WEEK') {
  //     newDate.setDate(newDate.getDate() + direction * 7);
  //   } else if (view === 'MONTH') {
  //     newDate.setMonth(newDate.getMonth() + direction);
  //   } else if (view === 'YEAR') {
  //     newDate.setFullYear(newDate.getFullYear() + direction);
  //   }

  //   setCurrentDate(newDate);
  //   setSelectedType("Total")
  // setChartData([])

  // };
  const shiftDate = (date) => {
    const today = new Date();
    if (date > today) return; // Block future dates

    const newDate = new Date(date);

    if (view === 'DAY') {
      newDate.setDate(newDate.getDate());
    } else if (view === 'WEEK') {
      newDate.setDate(newDate.getDate());
    } else if (view === 'MONTH') {
      newDate.setMonth(newDate.getMonth());
    } else if (view === 'YEAR') {
      newDate.setFullYear(newDate.getFullYear());
    }

    setCurrentDate(newDate);
    setSelectedType("Total");
    setChartData([]);
    setShowCalendar(false);
  };

  const typeKeyMap = {
    Total: 'totalCount',
    Active: 'activeCount',
    Completed: 'completedCount',
    Canceled: 'cancelledCount',
    Expired: 'expiredCount',
  };
  const formatDate = (date, isStart = true) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}T${isStart ? '00:00:00' : '23:59:59'}`;
  };
  const getRangeByModeFromDate = (mode, fromDate) => {
    let from = new Date(fromDate);
    let to = new Date(fromDate);

    if (mode === "Day") {
      // same day
      to = new Date(from);
    } else if (mode === "Week") {
      to.setDate(to.getDate() + 6);
    } else if (mode === "Month") {
      from = new Date(from.getFullYear(), from.getMonth(), 1);
      to = new Date(from.getFullYear(), from.getMonth() + 1, 0);
    } else if (mode === "Year") {
      from = new Date(from.getFullYear(), 0, 1);
      to = new Date(from.getFullYear(), 11, 31);
    }

    return {
      fromDate: formatDate(from, true),
      toDate: formatDate(to, false),
      groupBy: mode,
    };
  };

  const getRangeByModeToDate = (mode, toDate) => {
    let from = new Date(toDate);
    let to = new Date(toDate);

    if (mode === "Day") {
      from = new Date(to);
    } else if (mode === "Week") {
      to.setDate(to.getDate() + 6);
    } else if (mode === "Month") {
      from = new Date(to.getFullYear(), to.getMonth(), 1);
      to = new Date(to.getFullYear(), to.getMonth() + 1, 0);
    } else if (mode === "Year") {
      from = new Date(to.getFullYear(), 0, 1);
      to = new Date(to.getFullYear(), 11, 31);
    }

    return {
      fromDate: formatDate(from, true),
      toDate: formatDate(to, false),
      groupBy: mode,
    };
  };



  // This updates range1 and sets it to state
  const updateRange1FromDate = (from) => {
    const r1 = getRangeByModeFromDate(selectedMode, from);
    setRange1({ ...r1, groupBy: selectedMode?.toLowerCase() });
  };

  // This updates range2 and sets it to state
  const updateRange2FromDate = (to) => {
    const r2 = getRangeByModeToDate(selectedMode, to);

    setRange2({ ...r2, groupBy: selectedMode?.toLowerCase() });
  };

  // Handlers called by date pickers
  const handleFromDateChange = (date) => {
    setFromDate(date);
    if (date) updateRange1FromDate(date);
  };

  const handleToDateChange = (date) => {
    setToDate(date);
    if (date) updateRange2FromDate(date);
  };

  // Update ranges whenever fromDate or selectedMode changes
  useEffect(() => {
    if (!fromDate) return;
    updateRange1FromDate(fromDate);
  }, [fromDate, selectedMode]);

  // Update ranges whenever toDate or selectedMode changes
  useEffect(() => {
    if (!toDate) return;
    updateRange2FromDate(toDate);
  }, [toDate, selectedMode]);

  const getLabel = () => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const current = new Date(currentDate);
    current.setHours(0, 0, 0, 0);

    const formatShort = (date) =>
      date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

    const formatRange = (start, end) => `${formatShort(start)} ~ ${formatShort(end)}`;

    if (view === 'DAY') {
      const diffDays = Math.floor((current - today) / (1000 * 60 * 60 * 24));
      if (diffDays === 0) return `${current.toDateString()} (Today)`;
      if (diffDays === -1) return `${current.toDateString()} (Yesterday)`;
      if (diffDays === 1) return `${current.toDateString()} (Tomorrow)`;
      return current.toDateString();
    }

    if (view === 'WEEK') {
      const getMonday = (date) => {
        const d = new Date(date);
        const day = d.getDay(); // Sunday=0, Monday=1 ... Saturday=6
        const diff = (day === 0 ? -6 : 1) - day; // If Sunday (0), go back 6 days, else go back to Monday
        d.setDate(d.getDate() + diff);
        d.setHours(0, 0, 0, 0);
        return d;
      };

      const currentWeekStart = getMonday(current);
      const currentWeekEnd = new Date(currentWeekStart);
      currentWeekEnd.setDate(currentWeekStart.getDate() + 6);
      currentWeekEnd.setHours(0, 0, 0, 0);

      const todayWeekStart = getMonday(today);

      const diffWeeks = Math.floor((currentWeekStart - todayWeekStart) / (7 * 24 * 60 * 60 * 1000));

      if (diffWeeks === 0) return 'Current Week';
      if (diffWeeks === -1) return 'Last Week';
      if (diffWeeks === 1) return 'Next Week';

      return formatRange(currentWeekStart, currentWeekEnd);
    }


    if (view === 'MONTH') {
      const diffMonths =
        (current.getFullYear() - today.getFullYear()) * 12 + (current.getMonth() - today.getMonth());

      const start = new Date(current.getFullYear(), current.getMonth(), 1);
      const end = new Date(current.getFullYear(), current.getMonth() + 1, 0);

      if (diffMonths === 0) return 'Current Month';
      if (diffMonths === -1) return 'Last Month';
      if (diffMonths === 1) return 'Next Month';

      return formatRange(start, end);
    }

    if (view === 'YEAR') {
      const year = current.getFullYear();
      const currentYear = today.getFullYear();

      const start = new Date(year, 0, 1);
      const end = new Date(year, 11, 31);

      const diffYears = year - currentYear;

      if (diffYears === 0) return 'Current Year';
      if (diffYears === -1) return 'Last Year';
      if (diffYears === 1) return 'Next Year';

      return formatRange(start, end);
    }

    return '';
  };


  const handleViewChange = (selectedView) => {
    setView(selectedView);
    setCurrentDate(new Date());
    setChartData([])
    setSelectedType("Total")
    // You can add other logic here if needed in the future
  };
  const counts = async (data) => {
    // setIsLoading(true)
    try {
      const response = await tmdbApi.getCounts(
       { ...data,clientid:id}
      );

      console.log(response);
      // setChartData(response?.result?.result)
      setSummary(response?.result)
      setCurrentData([])
      setCompareData([])
      // setIsLoading(false)

      // Example conditional navigation (uncomment and customize as needed):
      // if (response?.result === "PENDING APPROVAL") {
      //   setBtnLoader(false);
      //   navigate("/thankyou");
      // } else {
      //   setBtnLoader(false);
      //   navigate("/verifyaccount");
      // }

    } catch (error) {
      console.error("Error in dashboard API call:", error);
      // Optionally, you can also:
      // setBtnLoader(false);
      // show error to user
    }
  };
  const dashboard = async (data) => {
    setIsLoading(true)
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    try {
      const response = await tmdbApi.dashboard(
        {...data,clientid:id,timeZone:timeZone}
      );
      if (response?.result === "Invalid token or Expired") {
        setShowSessionPopupup(true)
      } else {
        console.log(response);
        setChartData(response?.result?.result)
        // setSummary(response?.result?.summary)
        setCurrentData([])
        setCompareData([])
        setIsLoading(false)
      }


      // Example conditional navigation (uncomment and customize as needed):
      // if (response?.result === "PENDING APPROVAL") {
      //   setBtnLoader(false);
      //   navigate("/thankyou");
      // } else {
      //   setBtnLoader(false);
      //   navigate("/verifyaccount");
      // }

    } catch (error) {
      console.error("Error in dashboard API call:", error);
      // Optionally, you can also:
      // setBtnLoader(false);
      // show error to user
    }
  };


  const getStore = (e) => {
    // GetTimeActivity()
    const token = localStorage.getItem("token")
    // const userdata = localStorage.getItem("userdata")
    // console.log('userdata--->',userdata.username)
    // let userToken = userdata && userdata.token
    // console.log('userToken--->',userToken)
    axios({
      method: 'POST',
      url: `${lambda}/getStores?appname=${appname}&clientid=${useruniqueid}&token=${token}`,
      // + "&token=" + token,
    })
      .then(function (response) {
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          if (response?.data?.result.length > 0) {
            const result = response?.data?.result;
            // let roleCount = userData?.subscription?.features || []
            // const limits = {};
            // roleCount.forEach(item => {
            //     if (item.label && item.label.startsWith("Max")) {
            //         const key = normalize(item.label.replace("Max", "").replace("Managers", "Manager").replace("Officers", "Officer"));
            //         limits[key] = item.value;
            //     }
            // });
            // if (limits?.stores) {
            //     setStoresMaxLimitReached(limits.stores <= result.length)
            // }
            setIsLoading(false)
            setLocationData(result)
            //  editUser?.companydetails?.[0].accountmanager
          } else {
            // setInvalidContent(true)
            setIsLoading(false)
            // setLocationData(response?.data?.result)
          }

        }

        // setDisableSaveBtn(false)
      });
  }
  const handleStoreChange = (e) => {
    setSelectedStoreId(e.target.value);

    console.log("Selected Store ID:", e.target.value);
  };
  const handleFilterClick = (type) => setSelectedType(type);
  const handleClickCompare = async () => {
    setBtnLoader(true);
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let payload, payload1;

     if (selectedStoreId?.length > 0) {
      payload = { ...range1, storeid: selectedStoreId,clientid:id,timeZone:timeZone };
      payload1 = { ...range2, storeid: selectedStoreId,clientid:id,timeZone:timeZone };
    } else {
      payload = {...range1,clientid:id,timeZone:timeZone};
      payload1 = {...range2,clientid:id,timeZone:timeZone};
    }

    try {
      const response = await tmdbApi.dashboard(payload);
      const response1 = await tmdbApi.dashboard(payload1);
      const statsticsResp = await tmdbApi.getStatstics(payload);
      const statsticsResp1 = await tmdbApi.getStatstics(payload1);
      const respCounts = await tmdbApi.getCounts(payload);
      const respCounts1 = await tmdbApi.getCounts(payload1);
      const allStatsArray = [
        { data: statsticsResp?.result },
        { data: statsticsResp1?.result },

      ];
      const allCountsArray = [{ data: respCounts?.result },
      { data: respCounts1?.result },]
      setStatisticsData(allStatsArray)
      setAllCounts(allCountsArray)
      setCurrentData(response?.result?.result);
      setCompareData(response1?.result?.result);
      setShow(false);
    } catch (error) {
      console.error("Error in dashboard API call:", error);
    }

    setBtnLoader(false);
  };

  const getStatstics = async (data) => {
    const [past, current, future] = getPastCurrentFuturePayloads(data);

    const addStoreIdIfPresent = (payload) => {
      return selectedStoreId?.length > 0 ? { ...payload, storeid: selectedStoreId,clientid:id } : {...payload,clientid:id};
    };

    const pastPayload = addStoreIdIfPresent(past);
    const currentPayload = addStoreIdIfPresent(current);
    const futurePayload = addStoreIdIfPresent(future);

    // Print payloads for debugging
    console.log("Past Payload:", pastPayload);
    console.log("Current Payload:", currentPayload);
    console.log("Future Payload:", futurePayload);

    try {
      const [pastResponse, currentResponse, futureResponse] = await Promise.all([
        tmdbApi.getStatstics(pastPayload),
        tmdbApi.getStatstics(currentPayload),
        tmdbApi.getStatstics(futurePayload),
      ]);
      const allStatsArray = [
        { data: pastResponse?.result },
        { data: currentResponse?.result },
        { data: futureResponse?.result },
      ];
      setStatisticsData(allStatsArray)
      console.log("All Stats Array:", allStatsArray);
      // Optional: set responses to state
      // setPastData(pastResponse?.result?.result);
      // setCurrentData(currentResponse?.result?.result);
      // setFutureData(futureResponse?.result?.result);

      setShow(false);
    } catch (error) {
      console.error("Error in getStatstics API call:", error);
    }
  };



  const handleCancel = () => {

    const today = new Date();
    setView("DAY")
    setCurrentDate(today);
    const defaultMode = "Day"; // use "day" or "Day" based on your logic
    setSelectedMode(defaultMode);

    // reset date pickers
    setFromDate(today);
    setToDate(today);

    // reset range1 and range2
    const r1 = getRangeByModeFromDate(defaultMode, today);
    const r2 = getRangeByModeToDate(defaultMode, today);

    setRange1({ ...r1, groupBy: defaultMode.toLowerCase() });
    setRange2({ ...r2, groupBy: defaultMode.toLowerCase() });


    // optionally reset current store
    // setCurrentStore(""); or keep currentStore unchanged
  };
  const handleEdit = () => {
    setShow(true)
  }
  return (
    <>
      {showSessionPopupup && <SessionPopup />}

      <div id="layout-wrapper">
        <Header />
        <Sidebar />

        <div className="main-content user-management Dashboard-page">

          <div className="page-content">
            {isLoading ? <Loader /> :
              <div className="container-fluid">
                <div className="row breadcrumb">
                  <div className="col-lg-12">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <h4 className="mb-2 card-title">DASHBOARD</h4>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="p-4 bg-white shadow-lg rounded-lg Dashboard-wrapper">
                  {currentData?.length > 0 && compareData?.length > 0 ? <div className="d-flex justify-content-between align-items-center mb-3">
                    {/* Cancel Button on the left */}
                    <button className="stroke-btn-style" onClick={handleCancel}>
                      Cancel
                    </button>

                    {/* Edit Button on the right */}
                    <button className=" fill-btn-style" onClick={handleEdit}>
                      Edit
                    </button>
                  </div> :
                    <>
                      <div className="row align-items-center gy-3 mb-4">
                        <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                          <div className="input-group">
                            <span className="input-group-text">
                              <span className="material-symbols-outlined">store</span>
                            </span>
                            <select className="form-select" onChange={handleStoreChange} value={selectedStoreId}>
                              <option value="">All Locations</option>
                              {locationData?.map((item) => (
                                <option key={item.storeid} value={item.storeid}>
                                  {item.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-12 col-sm-4 col-md-3 col-lg-2">
                          <button className="btn compare-btn" onClick={handleCompare}>
                            <span className="material-symbols-outlined">text_compare</span>
                            Compare
                          </button>
                        </div>

                        <div className="col-12 col-md-5 col-lg-7 text-md-end d-flex flex-wrap justify-content-md-end align-items-center gap-2">
                          <div className="gap-1 me-2 date-selecting-wrapper">
                            {/* <button className="px-3 py-2 rounded-lg left-btn" onClick={() => shiftDate(-1)}>
      <span className="material-symbols-outlined">chevron_left</span>
    </button> */}

                            <span className="px-3 py-2 rounded-lg text-sm fw-semibold" onClick={() => setShowCalendar(!showCalendar)}>
                              {getLabel()}
                            </span>
                            {showCalendar && (
                              <div
                                className="position-absolute bg-white shadow p-2 mt-2 rounded"
                                style={{ zIndex: 10, top: 33 }}
                              >

                                {/* <DatePicker
              // selected={selectedDate}
              onChange={shiftDate}
              inline
              {...getDatePickerProps()}
            /> */}
                                <div ref={calendarRef}>
                                  <DatePicker
                                    className="form-control custom-date"
                                    inline
                                    selected={currentDate}
                                    onChange={shiftDate}
                                    // onBlur={() => setShowCalendar(false)}
                                    {...getDatePickerProps()}
                                    popperProps={{
                                      modifiers: [
                                        {
                                          name: 'preventOverflow',
                                          options: {
                                            boundary: 'viewport',
                                          },
                                        },
                                      ],
                                    }}
                                  />
                                </div>


                              </div>
                            )}
                            {/* <button className="px-3 py-2 rounded-lg right-btn" onClick={() => shiftDate(1)}>
      <span className="material-symbols-outlined">chevron_right</span>
    </button> */}
                          </div>

                          <div className="btn-group" role="group">
                            {views.map((viewOption) => (
                              <button
                                key={viewOption}
                                className={`btn btn-style ${view === viewOption ? 'active' : ''}`}
                                onClick={() => handleViewChange(viewOption)}
                              >
                                {viewOption.charAt(0) + viewOption.slice(1).toLowerCase()}
                              </button>
                            ))}
                          </div>

                        </div>

                      </div>

                      <div className="row g-3 mb-2 card-stat-wrapper">
                        {["Total", "Active", "Completed", "Canceled", "Expired"].map((type) => (
                          <div key={type} className="col-12 col-sm">
                            <div className="card stat-card" onClick={() => handleFilterClick(type)} style={{ cursor: 'pointer' }}>
                              <div className="d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center gap-3">
                                  <div className={`value-color-placeholder ${(type === "Canceled" ? "cancelled" : type.toLowerCase())}-color`}></div>
                                  <span className="value-txt-Style">{type}</span>
                                </div>

                                <span className="value-txt-Style">{summary[typeKeyMap[type]]}</span>


                              </div>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div class="row g-3 mb-4 admin-dashboard-wrapper Visitor-cards-wrapper ">
                        <div class="col-md-4">
                          <div class="card dashboard-box features-box">
                            <div class="card-body">
                              <div class="d-flex">
                                <div class="flex-grow-1">
                                  <p class="feu-txt-18">Visitors in Store</p>
                                  <h4 class="feu-txt-20">{summary?.activeCount}</h4>
                                </div>
                                <div class="flex-shrink-0 align-self-center">
                                  <div class="feu-icon-section">
                                    <span class="material-symbols-outlined">
                                      storefront
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-4">
                          <div class="card dashboard-box features-box">
                            <div class="card-body">
                              <div class="d-flex">
                                <div class="flex-grow-1">
                                  <p class="feu-txt-18">Forecast <span className="feu-txt-10">(Visitors in 30 min)</span></p>
                                  <h4 class="feu-txt-20">{summary?.forecastCount}</h4>
                                </div>
                                <div class="flex-shrink-0 align-self-center">
                                  <div class="feu-icon-section">
                                    <span class="material-symbols-outlined">
                                      lightbulb
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-4">
                          <div class="card dashboard-box features-box">
                            <div class="card-body">
                              <div class="d-flex">
                                <div class="flex-grow-1">
                                  <p class="feu-txt-18">Forecast <span className="feu-txt-10">(Visitors for Today)</span></p>
                                  <h4 class="feu-txt-20">{summary?.totalCount}</h4>
                                </div>
                                <div class="flex-shrink-0 align-self-center">
                                  <div class="feu-icon-section">
                                    <span class="material-symbols-outlined">
                                      lightbulb
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </>
                  }


                  <StackedBarChart filterType={filterType} />

                  {currentData?.length > 0 && compareData?.length > 0 && (
                    <div className="mb-4">
                      <DataTable
                        columns={countColumns}
                        keyField="_id"
                        data={allCounts}
                        direction="auto"
                        highlightOnHover
                        fixedHeaderScrollHeight="300px"
                        responsive
                        persistTableHead
                        className="count-table mt-2"
                      />
                    </div>
                  )}

                  <div className="mb-4">
                    <h5 className="mb-2 form-title">Statistics for selected period</h5>

                    <DataTable
                      columns={columns}
                      keyField="_id"
                      data={statisticsData}
                      direction="auto"
                      highlightOnHover
                      fixedHeaderScrollHeight="300px"
                      responsive
                      persistTableHead
                      className="statistics-table"
                    />


                  </div>

                </div>
              </div>}
            <Modal show={show} onHide={() => setShow(false)} centered className="compare-modal">
              <Modal.Header closeButton className="header-style">
                <Modal.Title>COMPARE</Modal.Title>
              </Modal.Header>

              <Modal.Body>
                <div className="compare-body">
                  <div className="btn-group align-items-center" role="group">

                    {["Day", "Week", "Month", "Year"].map((mode) => (
                      <button
                        key={mode}
                        className={`btn btn-style ${selectedMode === mode ? "active" : ""}`}
                        onClick={() => setSelectedMode(mode)}
                      >
                        {mode}
                      </button>
                    ))}

                  </div>

                  <div className="date-input">
                    <div className="input-group custom-date-wrapper">
                      <DatePicker
                        className="form-control custom-date"
                        selected={fromDate}
                        onChange={handleFromDateChange}
                        {...getPickerProps()}
                        popperProps={{
                          modifiers: [
                            {
                              name: 'preventOverflow',
                              options: {
                                boundary: 'viewport',
                              },
                            },
                          ],
                        }}
                      />
                    </div>

                    <p className="to-text">To</p>

                    <div className="input-group custom-date-wrapper">
                      <DatePicker
                        className="form-control custom-date"
                        selected={toDate}
                        onChange={handleToDateChange}
                        {...getPickerProps()}
                        popperProps={{
                          modifiers: [
                            {
                              name: 'preventOverflow',
                              options: {
                                boundary: 'viewport',
                              },
                            },
                          ],
                        }}
                      />
                    </div>
                  </div>

                </div>
              </Modal.Body>

              <Modal.Footer className="justify-content-end pt-0">
                <button className="fill-btn save_continue" onClick={handleClickCompare} disabled={btnLoader}>
                  {btnLoader ? <img src={`${image}${appname}/images/web/rotate_right.svg`} className="loading-icon" id="loginPwdLoading" /> : null} COMPARE
                </button>
              </Modal.Footer>
            </Modal>
            <Footer id="footer" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewDashBoard;
